export default function NewsletterSection() {
  return (
    <section className="py-14">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="relative rounded-2xl overflow-hidden bg-secondary-500 p-10 md:p-14 text-center">
          <div className="relative z-10">
            <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-accent-500 flex items-center justify-center">
              <i className="ri-mail-send-line text-2xl text-background-50"></i>
            </div>
            <h3
              className="text-xl md:text-2xl font-bold text-background-50 mb-2"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              订阅更新通知
            </h3>
            <p className="text-sm text-background-50/70 mb-6 max-w-md mx-auto">
              第一时间获取最新韩漫更新提醒，不错过任何精彩内容
            </p>
            <form
              data-readdy-form
              className="flex flex-col sm:flex-row items-center justify-center gap-3 max-w-md mx-auto"
              onSubmit={async (e) => {
                e.preventDefault();
                const form = e.currentTarget;
                const honeypot = (form.querySelector('[name="website_alt"]') as HTMLInputElement)?.value?.trim();
                if (honeypot) return;

                const formData = new FormData(form);
                try {
                  const res = await fetch("https://readdy.ai/api/form/d9ornf2ftmtnfcfh0cv0", {
                    method: "POST",
                    headers: { "Content-Type": "application/x-www-form-urlencoded" },
                    body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
                  });
                  const text = await res.text();
                  let msg = "订阅成功！感谢您的关注。";
                  try {
                    const parsed = JSON.parse(text);
                    if (res.ok && parsed?.code === "OK") {
                      msg = "订阅成功！感谢您的关注。";
                      form.reset();
                    } else {
                      msg = parsed?.meta?.message || parsed?.message || "订阅失败，请稍后再试。";
                    }
                  } catch {
                    msg = res.ok ? "订阅成功！感谢您的关注。" : "订阅失败，请稍后再试。";
                  }
                  alert(msg);
                } catch {
                  alert("网络异常，请稍后再试。");
                }
              }}
            >
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                style={{
                  position: "absolute",
                  left: "-9999px",
                  opacity: "0",
                  height: "0",
                  width: "0",
                  pointerEvents: "none",
                }}
              />
              <input
                type="email"
                name="email"
                required
                placeholder="输入您的邮箱"
                className="flex-1 w-full sm:w-auto px-5 py-3 rounded-full bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 outline-none border border-transparent focus:border-accent-400 transition-colors"
              />
              <button
                type="submit"
                className="w-full sm:w-auto px-6 py-3 rounded-full bg-accent-500 hover:bg-accent-600 text-background-50 text-sm font-medium transition-colors whitespace-nowrap"
              >
                立即订阅
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}